import Loadable from 'react-loadable';
import { Loading } from '../../common/navigation';

const KeyLearningArea = Loadable({
  loader: () => import('./components/key-learning-area'),
  loading: Loading,
});
const Courses = Loadable({
  loader: () => import('./components/courses'),
  loading: Loading,
});
export const routes = [
  {
    path: '/key-learning-area',
    exact: true,
    name: 'Key Learning Area',
    component: KeyLearningArea,
  },
  {
    path: '/key-learning-area/:id',
    exact: true,
    name: 'Courses',
    component: Courses,
  },
];
export * from './components';
